export default "__VITE_ASSET__BTjhv0ca__"